import {Service} from "@/services/superclasses/service";
import {MemberInvite} from "@/interfaces/member-invite";
import {FormResponse} from "@/interfaces/form-response";
import {MemberInviteAccept} from "@/interfaces/member-invite-accept";

const api = window.contextPath + '/rest/member-invites';

export class MemberInviteService extends Service {

    public accept = async (data: MemberInviteAccept): Promise<FormResponse<MemberInviteAccept>> => {
        return this.data(await this.post<FormResponse<MemberInviteAccept>>(api + "/accept-invite", data))
    };

    public load = async (token: string): Promise<MemberInvite> => {
        return this.data(await this.get<MemberInvite>(api + "/by-token/" + token))
    };

}

export const memberInviteService = new MemberInviteService();